import React from 'react';
import { Link } from 'react-router-dom';
import './PaymentSuccess.css';

const PaymentSuccess = () => {
    return (
        <div className="payment-success-container">
            <div className="payment-success-card">
                {/* Animated Checkmark Icon */}
                <div className="success-icon">
                    <div className="checkmark">
                        <svg
                            width="80"
                            height="80"
                            viewBox="0 0 80 80"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="40"
                                cy="40"
                                r="35"
                                fill="#10B981"
                                stroke="#059669"
                                strokeWidth="2"
                                className="checkmark-circle"
                            />
                            <path
                                d="M25 40L35 50L55 30"
                                stroke="white"
                                strokeWidth="4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="checkmark-path"
                            />
                        </svg>
                    </div>
                </div>

                {/* Success Content */}
                <div className="success-content">
                    <h1 className="success-title">Payment Successful</h1>
                    <p className="success-subtitle">
                        Thank you! Your payment has been processed successfully.
                    </p>
                </div>

                {/* Action Button */}
                <div className="success-actions">
                    <Link to="/dashboard" className="dashboard-btn">
                        <span>Go to Dashboard</span>
                    </Link>
                </div>

                {/* Decorative Elements */}
                <div className="success-particles">
                    <div className="particle particle-1">🎉</div>
                    <div className="particle particle-2">✨</div>
                    <div className="particle particle-3">🎊</div>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;
